import { render } from "./GalleryModal.vue?vue&type=template&id=3d72d3ca&scoped=true"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"

import "./GalleryModal.vue?vue&type=style&index=0&id=3d72d3ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d72d3ca"

export default script